require('./bootstrap');

import '@fortawesome/fontawesome-free/css/all.min.css';
import './vendor/laravel-core/sortableTable.js'

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

// Explicit BS5 tooltip init via window.tabler.Tooltip (exported by tabler.min.js IIFE).
// Handles data-bs-html so rich tooltip content renders correctly.
document.addEventListener('DOMContentLoaded', function () {
    const TooltipConstructor = window.tabler && window.tabler.Tooltip;
    if ( ! TooltipConstructor) { return; }
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (el) {
        new TooltipConstructor(el, { html: el.dataset.bsHtml === 'true' });
    });
});
